import { inject, Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ParametersService {
  private http = inject(HttpClient);
  private readonly url = `${environment.apiUrl}/parameters`;
  lastUpdatedAt = signal<Date | null>(null);

  LoadLastUpdated() {
    this.http
      .get<{ lastUpdatedAt: string | null }>(`${this.url}/last-updated`)
      .subscribe((res) => {
        const date = res.lastUpdatedAt;
        date && this.lastUpdatedAt.set(new Date(date));
      });
  }
}
